// 动画
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { animated, useSpring } from "react-spring";
import { color, Text } from "./Styles";

export default ({ isLandingPage }) => {
  const { t, i18n } = useTranslation();

  const heroRef = useRef();

  let scrollHeight = heroRef.current ? heroRef.current.scrollHeight : 0;

  const heroToggle = useSpring({
    overflow: "hidden",
    height: isLandingPage ? scrollHeight : 0
  });

  return (
    <animated.div ref={heroRef} style={heroToggle}>
      <Text scale={12} p={0.75} center>
        <Text mb={0.5}>{t("持有即获得质押收益")}</Text>
        <Text scale={1} color={color.gray} normal paragraph>
          {i18n.language === 'zh' ? '持有 vETH 即可获得 ETH 2.0 Staking 收益，操作简单，无需锁仓，不限金额' : 'Hold vETH to get ETH 2.0 staking reward, simple operation, no lockup, unlimited amount.'}
        </Text>
      </Text>
    </animated.div>
  );
};
